"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCSSFunction = void 0;
const cssFunctionRegexp = /(?<name>[\w-]+)\((?<value>.*?)\)/;
function parseCSSFunction(string) {
    var _a;
    const { name, value } = ((_a = string.match(cssFunctionRegexp)) === null || _a === void 0 ? void 0 : _a.groups) || {};
    return { name: name || null, value: value || null };
}
exports.parseCSSFunction = parseCSSFunction;
